import React, { useMemo, useState } from 'react';
import { Button, Grid, useTheme } from '@mui/material';
import VenueDrawer from '../../../components/VenueDrawer';

export const VenuesPanel = ({ organization, afterConfirm }) => {
  const theme = useTheme();
  const [openCreateVenueModal, setOpenCreateVenueModal] = useState(false);

  const onClickAddVenue = () => {
    setOpenCreateVenueModal(true);
  };

  const venuesSorted = useMemo(() => {
    const venues = organization?.venues || [];
    const active = venues.filter((v) => !v.discardedAt);
    const archived = venues.filter((v) => v.discardedAt);
    return [...active, ...archived];
  }, [organization?.venues]);

  return (
    <div style={{ margin: theme.spacing(2) }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div style={{ display: 'flex' }}>
            <div style={{ flexGrow: 1 }} />
            <Button
              variant="contained"
              color="secondary"
              onClick={onClickAddVenue}
              disabled={organization.discardedAt}
            >
              Add Venue
            </Button>
          </div>
        </Grid>
        {venuesSorted.map((v) => (
          <Grid item xs={12} key={v.id}>
            <Button
              variant="contained"
              href={`/admin/venues/${v.id}`}
              color={'primary'}
            >
              {v.discardedAt ? '(Archived)' : ''} {v.name}
            </Button>
          </Grid>
        ))}
      </Grid>
      <VenueDrawer
        refetchVenues={afterConfirm}
        organization={organization}
        open={openCreateVenueModal}
        onClose={() => setOpenCreateVenueModal(false)}
      />
    </div>
  );
};
